<dialog [id]="modalDialogId" class="modal">
    <div class="modal-box max-w-md flex flex-col text-center p-0 overflow-hidden">

        <!-- Header -->
        <div class="flex flex-col items-center px-8 pt-8 pb-6">
            <div class="h-14 w-14 rounded-full bg-error/10 flex items-center justify-center">
                <svg width="26" height="26" viewBox="0 0 24 24" class="text-error" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path d="M3 6h18" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                    <path d="M8 6V4h8v2" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                    <path d="M6 6l1 16h10l1-16" stroke="currentColor" stroke-width="2" stroke-linejoin="round" />
                    <path d="M10 11v6" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                    <path d="M14 11v6" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                </svg>
            </div>

            <h2 class="mt-4 font-bold text-2xl text-neutral-900">
                {{ 'settings.account.delete_dialog_title' | transloco }}
            </h2>

            <p class="text-neutral-700 text-base mt-3 leading-6">
                {{ 'settings.account.delete_dialog_desc' | transloco }}
            </p>

            <!-- Optional extra hint line -->
            <p class="text-neutral-500 text-sm mt-3">
                {{ 'settings.account.delete_dialog_hint' | transloco }}
            </p>
        </div>

        <!-- Divider -->
        <div class="h-px w-full bg-gray-200"></div>

        <!-- Actions -->
        <div class="px-6 py-5 flex gap-3 justify-between">
            <div class="w-1/2 h-[48px]">
                <app-custom-button (click)="closeModal(false)" buttonText="{{ 'shared.cancel' | transloco }}"
                    backgroundColor="bg-white" textColor="text-neutral-900" borderColor="border border-gray-300"
                    hoverBackgroundColor="hover:bg-gray-50" hoverBorderColor="hover:border-gray-400" hoverTextColor="text-neutral-900">
                </app-custom-button>
            </div>

            <div class="w-1/2 h-[48px]">
                <app-custom-button (click)="closeModal(true)"
                    buttonText="{{ 'settings.account.delete_confirm_cta' | transloco }}" backgroundColor="bg-error"
                    textColor="text-white" borderColor="border border-error" hoverBackgroundColor="hover:bg-error-800"
                    hoverBorderColor="hover:border-error-800">
                </app-custom-button>
            </div>
        </div>

    </div>

    <form method="dialog" class="modal-backdrop">
        <button (click)="closeModal(false)">Close</button>
    </form>
</dialog>